export default __webpack_public_path__ + "files/media/plane-mobile@2x.17c1b1c2.webp";